import { toast as sonnerToast, ExternalToast } from 'sonner';

// Re-export the toast function with full Shadcn API compatibility
const toast = Object.assign(
  (message: string | React.ReactNode, data?: ExternalToast) => {
    return sonnerToast(message, data);
  },
  {
    success: (message: string | React.ReactNode, data?: ExternalToast) => {
      return sonnerToast.success(message, data);
    },
    info: (message: string | React.ReactNode, data?: ExternalToast) => {
      return sonnerToast.info(message, data);
    },
    warning: (message: string | React.ReactNode, data?: ExternalToast) => {
      return sonnerToast.warning(message, data);
    },
    error: (message: string | React.ReactNode, data?: ExternalToast) => {
      return sonnerToast.error(message, data);
    },
    message: (message: string | React.ReactNode, data?: ExternalToast) => {
      return sonnerToast.message(message, data);
    },
    promise: <T>(
      promise: Promise<T> | (() => Promise<T>),
      data?: {
        loading?: string | React.ReactNode;
        success?:
          | string
          | React.ReactNode
          | ((data: T) => string | React.ReactNode);
        error?:
          | string
          | React.ReactNode
          | ((error: unknown) => string | React.ReactNode);
        finally?: () => void | Promise<void>;
      } & ExternalToast,
    ) => {
      return sonnerToast.promise(promise, data);
    },
    custom: (
      jsx: (id: string | number) => React.ReactElement,
      data?: ExternalToast,
    ) => {
      return sonnerToast.custom(jsx, data);
    },
    dismiss: (id?: string | number) => {
      return sonnerToast.dismiss(id);
    },
    loading: (message: string | React.ReactNode, data?: ExternalToast) => {
      return sonnerToast.loading(message, data);
    },
  },
);

export { toast };
